import { removeMask } from './masks';

export const moneyFormat = (value: string) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Number(value));
};

export function splitNameAndLastname(fullname: string) {
  const nameSplitted = { firstName: '', lastName: '' };
  const patientNameSeparate = fullname.split(' ');
  patientNameSeparate.forEach((name, index) => {
    if (index === 0) nameSplitted.firstName = name;
    else {
      if (nameSplitted.lastName) {
        if (name) nameSplitted.lastName = nameSplitted.lastName + ' ' + name;
      } else {
        if (name) nameSplitted.lastName = name;
      }
    }
  });
  return nameSplitted;
}

export const capitalize = (text: string): string => {
  if (!text) return '';
  return text
    .split(' ')
    .map(word => {
      if (checkCapitalize(word)) {
        return capitalizeWord(word);
      } else {
        return word.toLowerCase();
      }
    })
    .join(' ');
};

const checkCapitalize = (word: string): boolean => {
  switch (word) {
    case 'e':
    case 'a':
    case 'ao':
    case 'ou':
    case 'de':
    case 'da':
    case 'das':
    case 'do':
    case 'dos':
      return false;
    default:
      return true;
  }
};

const capitalizeWord = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const formatPhoneNumber = (value: string) => {
  if (value) {
    const clean = removeMask(value);
    return clean
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
      .replace(/(-\d{4})\d+?$/, '$1');
  }

  return '';
};
